"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  LOCATIONS: "svn_locations",
  PHOTO_HEIC: "sitevision-photos-backend-heic-heif-convert"
};
exports.default = _default;